import { Row, Col, Button } from 'react-bootstrap';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Welcome.css';

const WelcomeComponent = ({handleNextStep}) => {
  return (
    <Row className='welcome-container'>
      <Col className='text-start'>
        <h2>Aquí comienza tu viaje con happ 💞</h2>
        <h2>
          Queremos darte la bienvenida a la nueva forma de cuidar tu salud, de forma preventiva y en la palma de tu mano. <br></br>
          Este formulario de registro permitirá que, una vez realizado tu chequeo preventivo, puedas tener acceso inmediato y completo a nuestra App. 
        </h2>
        <h2>¡Gracias por confiar en nosotros!</h2>
        <div className="footer-row">
          <span className="cluster-text">Cluster: Araucana</span>
          <Button variant='primary'
            onClick={() => handleNextStep('prospect-register')}
          >Comenzar</Button>
        </div>
      </Col>
    </Row>
  );
};

export default WelcomeComponent;